module.exports = __webpack_public_path__ + "static/media/ico_mail.4a6a88b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Contacts/imgs/ico_mail.svg
// module id = 1683
// module chunks = 0